import * as React from 'react';
import { useGetLogHistoryQuery } from "../../../apis/LogHistory.api";
import { PrimaryLogHistory, LogHistory } from "../../../types/models/LogHistory";
import LogName from "../../../../timber/components/log/LogDetail/LogName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: LogHistory;
};

export const LogHistoryNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><LogName id={ data?.logId }/>
                    {data?.action && <> | </> }{ data?.action }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const LogHistoryName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetLogHistoryQuery(PrimaryLogHistory.fromId(id))
    return (<LogHistoryNameDisplay data={data}/>)
}

export default LogHistoryName;
